import { makeAutoObservable, autorun, runInAction, makeObservable, action, observable } from "mobx"
import default_logo from './img/isologo-kalenis.png'
import default_favicon from './img/favicon.png'
import { environment } from '../common'
import { lighten, hexAToRGBA, hexAToRGB, getRGBValues } from './color'

export const default_theme_values = {
    logo: default_logo,
    
    palette: {
        primary: "#195fc7",
	    secondary: "#dc004e",

    },
}

const default_tab_name = "Kalenis Customer Services"
export class Theme {

    connection = false
    values = default_theme_values
    use_default_theme = false
    logo = ""
    ready = false
    default = true
    tooltip_templates = []

    // get logo() {
    //     return this.values['logo']
    // }
    constructor(connection, use_default_theme=false) {
        makeObservable(this, {
            setTheme: action,
            ready: observable,
            values:observable,
            logo:observable,
            default:observable,
            setLogo:action,
            setDefault:action,
            setTooltipTemplates:action,
           
            
        })
        this.connection = connection;
        
        if(this.connection.api_path){
            this.getTheme()
            
        }
        else{
            this.setTheme(default_theme_values)
            this.setDefault(true)
        }
        

    }


    async getTooltipTemplates(theme_id){
        const abortController = new AbortController();
        let tooltip_templates = await this.connection.dispatch('GET','/theme/tooltip_templates',{ theme_id: theme_id }, false, true, false, abortController)
        return tooltip_templates

    }

    setTooltipTemplates(templates){
        this.tooltip_templates = templates
    }
    async getTheme() {
        let args = {}
        if (environment() === 'web'){
            args['host'] = window.location.host
        }
        else{
            args['host'] = ''
        }
        let values = default_theme_values
        const abortController = new AbortController();
        let theme = await this.connection.dispatch('GET', '/theme/host_theme', args, false, true, false, abortController)
        // let logo = false
        console.log("THE THEME GETTED")
        console.log(theme)
        let res = await this.connection.dispatch('GET', '/theme_logo', { theme_id: theme.id }, false, false, true, abortController)
        
        let logo = res.data
        
        
        
        if (theme) {
            values = theme;
            
            if(logo){
                if (environment() === 'web') {
                    // values["logo"] = URL.createObjectURL(logo)
                    this.setLogo( URL.createObjectURL(logo))
                    window.document.title = theme.tab_name ? theme.tab_name:default_tab_name
                    if(theme.has_favicon){
                        let favicon = await this.connection.dispatch('GET', '/theme/favicon', { theme_id: theme.id }, false, false, true, abortController)
                        favicon = URL.createObjectURL(favicon.data)
                        this.setFavicon(favicon)
                        
                    }
                    
                    

                    
                }
                else {
                        var reader = new FileReader();
                        reader.readAsDataURL(logo);
                        reader.onloadend = function () {
                            var base64data = reader.result;
                            // values['logo'] = base64data
                            this.setLogo(base64data)
                        }.bind(this)
                    
                    
    
                }
            }
            
            this.setTooltipTemplates(await this.getTooltipTemplates(theme.id))


        }
        this.setDefault(false)
        // if(theme){
        //     console.log("SETTING THEME TO LOCAL DB")
        //     if(this.connection.db_handler){
        //         this.connection.db_handler.setTheme(values)
        //     }
        // }
        
        return this.setTheme(values)


    }
    setLogo(value){
        this.logo = value
    }

    setFavicon(favicon){
        var link = document.querySelector("link[rel~='icon']");

        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        if(favicon){
            
            link.href = favicon;
        }
        
        
    }
    
    getTooltipTemplate(id){
        return this.tooltip_templates.find(t => t.id == id)
    }
    setDefault(value){
        this.default = value;
    }


    setTheme(values) {
        const env = environment()

        if(values.primary){
            values['light_selected'] = hexAToRGBA(lighten(values.primary, 40), '.3')
        }
        
        this.values = values;


        if (env === 'web') {
            this.setWebTheme(values)
        }
        this.ready = true
        return this

    }
    setWebTheme(theme) {
        document.documentElement.style.setProperty('--color-primary', getRGBValues(hexAToRGB(theme.primary)));
        document.documentElement.style.setProperty('--color-contrast-primary', 'rgb(255,255,255)');
        document.documentElement.style.setProperty('--color-lighten-primary', lighten(theme.primary, 12));
        document.documentElement.style.setProperty('--color-secondary', getRGBValues(hexAToRGB(theme.secondary)));
        document.documentElement.style.setProperty('--color-lighten-secondary', lighten(theme.secondary, 12));
        document.documentElement.style.setProperty('--color-disabled', 'lightgrey');
        document.documentElement.style.setProperty('--color-light-selected', hexAToRGBA(lighten(theme.primary, 40), '.3'));
        document.documentElement.style.setProperty('--color-secondary-light-selected', hexAToRGBA(lighten(theme.secondary, 40), '.3'));
        document.documentElement.style.setProperty('font-size', '1rem');

    }






}
